import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08709086"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "colors" }
const _hoisted_2 = { class: "colors__left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "brush-map__subtitle" }, "PRIME", -1))
const _hoisted_4 = { class: "colors__left-list" }
const _hoisted_5 = { class: "colors__right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "brush-map__subtitle" }, "PERIO", -1))
const _hoisted_7 = { class: "colors__right-list" }


import BrushMapListItem from './components/BrushMapListItem.vue'
import { BrushMapAddedBrushes } from '@/pages/BrushMapPage/brushMapAddedBrushes'
import { SelectedBrushType } from '@/shared/types'
import {
  CURAPROX_COLOR_LIST_LEFT,
  CURAPROX_COLOR_LIST_RIGHT,
} from '@/shared/constants/brushMapFirms'

interface Props {
  brushMapBrushes: BrushMapAddedBrushes
}


export default /*#__PURE__*/_defineComponent({
  props: {
    brushMapBrushes: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createVNode(BrushMapListItem, {
          brushMapBrushes: __props.brushMapBrushes,
          firstPosition: 0,
          list: _unref(CURAPROX_COLOR_LIST_LEFT),
          secondPosition: 5
        }, null, 8, ["brushMapBrushes", "list"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("ul", _hoisted_7, [
        _createVNode(BrushMapListItem, {
          brushMapBrushes: __props.brushMapBrushes,
          firstPosition: 0,
          list: _unref(CURAPROX_COLOR_LIST_RIGHT),
          secondPosition: 4
        }, null, 8, ["brushMapBrushes", "list"])
      ])
    ])
  ]))
}
}

})